// Apostroful desenat — semnătura brandului vorba, animat o dată la mount (SVG stroke).
// Moștenește dimensiunea din font-size-ul părintelui (em).
export default function DrawnApostrophe({ className = '' }) {
  return (
    <svg className={`drawn-apostrophe ${className}`.trim()} viewBox="0 0 22 50" aria-hidden="true" focusable="false">
      <path
        className="drawn-apostrophe__path"
        d="M 14 5 C 17 5, 18 9, 17 14 C 16 20, 13 27, 9 34 C 7 38, 5 41, 4 42"
        pathLength="100"
        fill="none"
        stroke="#E8A33D"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
